import { alpha } from "@mui/material/styles";
import { listClasses } from "@mui/material/List";
import { paperClasses } from "@mui/material/Paper";
import { buttonClasses } from "@mui/material/Button";
import { listItemIconClasses } from "@mui/material/ListItemIcon";
import { tablePaginationClasses } from "@mui/material/TablePagination";
//
import { paper } from "../../css";
// ----------------------------------------------------------------------
export function dataGrid(theme) {
    const paperStyles = paper({ theme, dropdown: true });
    return {
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    borderRadius: 24,
                    borderWidth: 0,
                    border: "1px solid #919EAB1F",
                    backgroundColor: "transparent",
                    borderBottom: `1px dashed transparent`,
                    "& .MuiDataGrid-filler > div": {
                        borderTop: "none !important",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: theme.palette.common.white,
                        borderRadius: "0px",
                        overflow: "hidden",
                        // borderBottom: "2px solid transparent !important",
                    },
                    "& .MuiDataGrid-columnHeader": {
                        backgroundColor: theme.palette.common.white,
                    },
                    "& .MuiDataGrid-cell": {
                        border: "none !important",
                        display: "flex",
                        alignItems: "center",
                        height: "auto",
                        fontFamily: theme.typography.fontFamily,
                        fontSize: theme.typography.body2.fontSize,
                        fontWeight: theme.typography.body2.fontWeight,
                        color: theme.palette.text.primary,
                        padding: theme.spacing(1),
                        "&:focus": {
                            outline: "none !important",
                        },
                        "&:focus-within": {
                            outline: "none !important",
                        },
                        "&.Mui-selected": {
                            outline: "none !important",
                        },
                        // Ensure Typography components inherit styles properly
                        "& .MuiTypography-root": {
                            fontFamily: "inherit",
                            fontSize: "inherit",
                            color: "inherit",
                        },
                    },
                    "& .MuiSvgIcon-root ": {
                        color: "rgba(69, 79, 91, 1)",
                    },
                    "& .MuiDataGrid-row": {
                        cursor: "pointer",
                        // Enable dynamic row heights
                        "& .MuiDataGrid-cell": {
                            height: "auto !important",
                            minHeight: "52px",
                            maxHeight: "none !important",
                        },
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                        fontWeight: "600 !important",
                        overflow: "visible !important",
                        fontSize: "14px !important",
                        color: theme.palette.text.secondary,
                    },
                    [`& .${tablePaginationClasses.root}`]: {
                        borderTop: 0,
                    },
                    [`& .${tablePaginationClasses.toolbar}`]: {
                        height: "40px",
                    },
                    "& .MuiDataGrid-row.Mui-selected": {
                        backgroundColor: alpha(theme.palette.primary.main, 0.2),
                    },
                    "& .MuiDataGrid-withBorderColor": {
                        border: "1px solid transparent",
                    },
                },
                cell: {
                    borderBottom: `1px dashed transparent`,
                },
                selectedRowCount: {
                    whiteSpace: "nowrap",
                },
                columnSeparator: {
                    color: theme.palette.divider,
                    display: "none",
                },
                toolbarContainer: {
                    padding: theme.spacing(2),
                    borderBottom: `1px dashed transparent`,
                    height: "40px",
                    backgroundColor: theme.palette.background.neutral,
                },
                paper: Object.assign(Object.assign({}, paperStyles), { padding: 0 }),
                menu: {
                    [`& .${paperClasses.root}`]: Object.assign({}, paperStyles),
                    [`& .${listClasses.root}`]: {
                        padding: 0,
                        [`& .${listItemIconClasses.root}`]: {
                            minWidth: 0,
                            marginRight: theme.spacing(2),
                        },
                    },
                },
                panelHeader: {
                    padding: theme.spacing(2),
                },
                footerContainer: {
                    marginTop: 8,
                    borderRadius: 0,
                    minHeight: 53,
                    background: "transparent",
                },
                panelFooter: {
                    padding: theme.spacing(2),
                    justifyContent: "flex-end",
                    borderTop: `dashed 1px transparent`,
                    [`& .${buttonClasses.root}`]: {
                        "&:first-of-type": {},
                        "&:last-of-type": {
                            marginLeft: theme.spacing(1.5),
                            color: theme.palette.background.paper,
                            backgroundColor: theme.palette.text.primary,
                        },
                    },
                },
                filterForm: {
                    padding: theme.spacing(2),
                },
                filterFormValueInput: {
                    marginLeft: theme.spacing(2),
                },
                filterFormColumnInput: {
                    marginLeft: theme.spacing(2),
                },
                filterFormOperatorInput: {
                    marginLeft: theme.spacing(2),
                },
            },
        },
    };
}
